/**
 * Manage company site pages
 */
import Ajax from '@/lib/ajax_wrapper'

function pagesPath(companyId, siteId) {
  return `/admin/companies/${companyId}/sites/${siteId}/pages`
}

/**
 * Read paginated company site pages
 *
 * @param {string} companyId
 * @param {string} siteId
 * @param {object} pagination
 * @param {integer} pagination.number
 * @param {integer} paginatino.perPage
 *
 * @returns {promise}
 */
export function readCompanySitePagesData(companyId, siteId, pagination) {
  return Ajax.request({
    url: pagesPath(companyId, siteId),
    page: pagination
  })
}

/**
 * Create a company site page
 *
 * @param {string} companyId
 * @param {string} siteId
 * @param {object} page
 * @param {string} page.name
 *
 * @returns {promise}
 */
export function createCompanySitePageData(companyId, siteId, page) {
  return Ajax.request({
    url: pagesPath(companyId, siteId),
    method: 'POST',
    data: {page}
  })
}

/**
 * Read a company site page
 *
 * @param {string} companyId
 * @param {string} siteId
 * @param {string} id
 *
 * @returns {promise}
 */
export function readCompanySitePageData(companyId, siteId, id) {
  return Ajax.request({
    url: `${pagesPath(companyId, siteId)}/${id}`
  })
}

/**
 * Update a company site page
 *
 * @param {string} companyId
 * @param {string} siteId
 * @param {string} id
 * @param {object} page
 * @param {string} page.name
 *
 * @returns {promise}
 */
export function updateCompanySitePageData(companyId, siteId, id, page) {
  return Ajax.request({
    url: `${pagesPath(companyId, siteId)}/${id}`,
    method: 'PATCH',
    data: {page}
  })
}

/**
 * Delete a company site page
 *
 * @param {string} companyId
 * @param {string} siteId
 * @param {string} id
 *
 * @returns {promise}
 */
export function deleteCompanySitePageData(companyId, siteId, id) {
  return Ajax.request({
    url: `${pagesPath(companyId, siteId)}/${id}`,
    method: 'DELETE'
  })
}
